/* global showSuccessToast */
/* global showDangerToast */

import React, { useState, useEffect } from "react";
import {
    getTargetByID,
    saveCheckStatus,
    getCheckOpen,
    getCheckClose,
    getCheckQuestions,
    getCheckAnswers,
    addQualityAnswer
} from "../../api/api";

const STARS = [1, 2, 3, 4, 5];

const CheckCallModal = ({ companyID, selectedTargetItem, onSaved }) => {
    const [checkQuestions, setCheckQuestions] = useState([]);
    const [checkOpen, setCheckOpen] = useState([]);
    const [checkClose, setCheckClose] = useState([]);
    const [checkAnswers, setCheckAnswers] = useState([]);
    const [questionRatings, setQuestionRatings] = useState([]);
    const [questionAnswers, setQuestionAnswers] = useState([]);

    useEffect(() => {
        if (!selectedTargetItem) return undefined;

        let cancelled = false;
        const targetID = selectedTargetItem.Target[0].id;
        setQuestionAnswers([]);
        setQuestionRatings([]);
        setCheckQuestions([]);
        setCheckOpen([]);
        setCheckClose([]);
        setCheckAnswers([]);

        getCheckQuestions(companyID, targetID).then(response => {
            if (!cancelled) {
                const questions = response.data.data.getQualityQuestionListing.edges;
                setCheckQuestions(questions);
                setQuestionRatings(Array(questions.length).fill(0));
            }
        });
        getCheckOpen(companyID, targetID).then(response => {
            if (!cancelled) setCheckOpen(response.data.data.getQualityOpenListing.edges);
        });
        getCheckClose(companyID, targetID).then(response => {
            if (!cancelled) setCheckClose(response.data.data.getQualityCloseListing.edges);
        });
        getCheckAnswers(companyID, selectedTargetItem.id).then(response => {
            if (!cancelled) setCheckAnswers(response.data.data.getQualityAnswerListing.edges.map(edge => edge.node));
        });

        return () => {
            cancelled = true;
        };
    }, [companyID, selectedTargetItem]);

    const handleSubmitQuality = async (e) => {
        e.preventDefault();
        if (!window.confirm("Vuoi procedere con il salvataggio definitivo della check call?")) return;

        for (let index = 0; index < checkQuestions.length; index++) {
            const plainData = {
                QualityQuestion: checkQuestions[index].node.id,
                answer: questionAnswers[index],
                rating: questionRatings[index],
            };
            const qualityResponse = await addQualityAnswer(plainData, companyID, selectedTargetItem.id);
            if (!qualityResponse?.data?.data?.createQualityAnswer?.output?.id) {
                console.error("Errore: risposta non valida durante l'aggiunta della quality answer", qualityResponse);
                showDangerToast("Errore nell'aggiunta della check call: ");
                return;
            }
        }
        showSuccessToast("Check call salvata con successo!");

        await saveCheckStatus(selectedTargetItem.id, { check: 1 });
        showSuccessToast("Attività aggiornata con successo!");
        const response = await getTargetByID(selectedTargetItem.id);
        const updatedTarget = response.data.data.getTargetItemListing.edges[0].node;
        if (onSaved) onSaved({ ...updatedTarget, check: 1 });

        window.$(document.getElementById("modal-order-item")).modal("hide");
    };

    const setAt = (setter, index, value) => setter(current => {
        const next = [...current];
        next[index] = value;
        return next;
    });

    return (
        <div>
            <form className="row" method="post" onSubmit={handleSubmitQuality}>
                {checkAnswers.length > 0 ? (
                    <div className="form-group col-12">
                        {checkAnswers.map((answer, index) => (
                            <div key={index} className="mb-3">
                                <div className="row">
                                    <div className="form-group col-8 mb-0">
                                        <h6><strong>{answer.QualityQuestion[0].question}</strong></h6>
                                    </div>
                                    <div className="form-group col-12">
                                        <p>{answer.answer}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <React.Fragment>
                        {checkOpen.length > 0 && (
                            <div className="form-group col-12 mt-4">
                                {checkOpen.map((question, index) => (
                                    <div key={index} className="mb-3">
                                        <h6><strong>{question.node.title}</strong></h6>
                                        <p>{question.node.open}</p>
                                    </div>
                                ))}
                            </div>
                        )}
                        {checkQuestions.length > 0 && (
                            <div className="form-group col-12">
                                {checkQuestions.map((question, index) => (
                                    <div key={index} className="my-4">
                                        <div className="row">
                                            <div className="form-group col-12">
                                                <h6><strong>{question.node.question}</strong></h6>
                                                <p>{question.node.description}</p>
                                                <textarea
                                                    maxLength={190}
                                                    className="form-control"
                                                    rows={3}
                                                    value={questionAnswers[index] || ""}
                                                    onChange={e => setAt(setQuestionAnswers, index, e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                        {checkClose.length > 0 && (
                            <div className="form-group col-12">
                                {checkClose.map((question, index) => (
                                    <div key={index} className="mb-3">
                                        <h6><strong>{question.node.title}</strong></h6>
                                        <p>{question.node.close}</p>
                                    </div>
                                ))}
                            </div>
                        )}
                        <div className="form-group col-12">
                            <button type="submit" className="btn btn-primary btn-block col">Salva check call</button>
                        </div>
                    </React.Fragment>
                )}
            </form>
        </div>
    );
};

export default CheckCallModal;
